import type { Ticket } from '@core/Areas/Account/Pages/Activity/types'
import { RacingEvents } from '@core/Areas/VenueMode/Components/Racing/Data/types'

export const isVenueModeTicket = (
  ticket: Ticket,
  venueModeEvents: RacingEvents | undefined
): boolean => {
  if (!ticket || !ticket.legs) return false

  const featureRaceLegs = ticket.legs.filter(f => f.eventType === 'Feature Races')

  const isVenueMode =
    !venueModeEvents || featureRaceLegs.length === 0
      ? false
      : featureRaceLegs.some(leg => venueModeEvents.some(event => event.sequence === leg.eventSeq))

  return isVenueMode
}
